import { render, staticRenderFns } from "./complaintTypeList.vue?vue&type=template&id=797399ee&scoped=true&"
import script from "./complaintTypeList.vue?vue&type=script&lang=js&"
export * from "./complaintTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797399ee",
  null
  
)

export default component.exports